import React from "react";
import cn from "classnames";
import styles from "./Formulaire.module.sass";
import useContactForm from "../../../hooks/useContactForm";

const Formulaire = () => {
  const {
    formData,
    formState,
    updateFormData,
    submitForm,
    resetFormState,
    canSubmit
  } = useContactForm();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    updateFormData(name, value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitForm();
  };

  return (
    <div className={cn("section-bg", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.row}>

          {/* Formulaire */}
          <div className={styles.form}>
            {formState.isSubmitted ? (
              <div className={styles.successMessage}>
                <div className={styles.successIcon}>✓</div>
                <h3>Message envoyé avec succès !</h3>
                <p>Votre demande a été envoyée avec succès. Nous vous répondrons dans les plus brefs délais.</p>

                <button className={cn("button", styles.button)} onClick={resetFormState}>
                  Envoyer un nouveau message
                </button>
              </div>
            ) : (
              <>
                <h2 className={styles.formTitle}>Contactez-nous</h2>
                <p className={styles.formSubtitle}>
                  Remplissez le formulaire ci-dessous pour nous contacter ou planifier un rendez-vous avec notre équipe commerciale.
                </p>

                {formState.message && (
                  <div className={cn(styles.message, {
                    [styles.messageSuccess]: formState.messageType === 'success',
                    [styles.messageError]: formState.messageType === 'error'
                  })}>
                    {formState.message}
                  </div>
                )}

                <form onSubmit={handleSubmit} className={styles.contactForm}>
                  {/* Type de demande */}
                  <div className={styles.field}>
                    <label htmlFor="type" className={styles.label}>
                      Type de demande *
                    </label>
                    <select
                      id="type"
                      name="type"
                      value={formData.type}
                      onChange={handleInputChange}
                      className={cn(styles.select, {
                        [styles.error]: formState.errors.type
                      })}
                      required
                    >
                      <option value="demo">Demande de démo</option>
                      <option value="rdv">Rendez-vous commercial</option>
                      <option value="assistance">Support technique</option>
                    </select>
                    {formState.errors.type && (
                      <span className={styles.errorText}>{formState.errors.type}</span>
                    )}
                  </div>

                  {/* Nom */}
                  <div className={styles.field}>
                    <label htmlFor="nom" className={styles.label}>
                      Nom complet *
                    </label>
                    <input
                      type="text"
                      id="nom"
                      name="nom"
                      value={formData.nom}
                      onChange={handleInputChange}
                      className={cn(styles.input, {
                        [styles.error]: formState.errors.nom
                      })}
                      placeholder="Votre nom et prénom"
                      required
                    />
                    {formState.errors.nom && (
                      <span className={styles.errorText}>{formState.errors.nom}</span>
                    )}
                  </div>

                  {/* Email */}
                  <div className={styles.field}>
                    <label htmlFor="email" className={styles.label}>
                      Adresse email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className={cn(styles.input, {
                        [styles.error]: formState.errors.email
                      })}
                      placeholder="votre@email.com"
                      required
                    />
                    {formState.errors.email && (
                      <span className={styles.errorText}>{formState.errors.email}</span>
                    )}
                  </div>

                  {/* Société */}
                  <div className={styles.field}>
                    <label htmlFor="societe" className={styles.label}>
                      Société / Organisation
                    </label>
                    <input
                      type="text"
                      id="societe"
                      name="societe"
                      value={formData.societe}
                      onChange={handleInputChange}
                      className={styles.input}
                      placeholder="Nom de votre organisation"
                    />
                  </div>

                  {/* Message */}
                  <div className={styles.field}>
                    <label htmlFor="message" className={styles.label}>
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      className={cn(styles.textarea, {
                        [styles.error]: formState.errors.message
                      })}
                      placeholder="Décrivez votre demande en détail..."
                      rows="5"
                      required
                    />
                    {formState.errors.message && (
                      <span className={styles.errorText}>{formState.errors.message}</span>
                    )}
                  </div>

                  {/* Honeypot field (hidden) */}
                  <input
                    type="text"
                    name="website"
                    value={formData.website}
                    onChange={handleInputChange}
                    style={{ display: 'none' }}
                    tabIndex="-1"
                    autoComplete="off"
                  />

                  <div className={styles.buttonContainer}>
                    <button disabled={!canSubmit} className={cn("button", styles.button)} onClick={resetFormState}>
                    {formState.isSubmitting ? (
                        <>
                          <span className={styles.spinner}></span>
                          Envoi en cours...
                        </>
                      ) : (
                        'Envoyer le message'
                      )}
                    </button>
                  </div>

                  <p className={styles.disclaimer}>
                    * Champs obligatoires. Vos données sont protégées et utilisées uniquement pour traiter votre demande.
                  </p>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Formulaire;
